import { type ReactNode } from 'react'

interface PassepartoutColorDetailsProps {
  description?: string
  children?: ReactNode
}

const PassepartoutColorDetails = ({
  description,
  children,
}: PassepartoutColorDetailsProps) => {
  return (
    <div className="w-full pt-2.5 pb-4 px-2.5 space-y-4">
      {!!description && (
        <div className="flex text-xs border-t pt-2.5">{description}</div>
      )}

      {children}
    </div>
  )
}

export default PassepartoutColorDetails
